import { render, staticRenderFns } from "./List-edit.vue?vue&type=template&id=6dd26eda&scoped=true"
import script from "./List-edit.vue?vue&type=script&lang=js"
export * from "./List-edit.vue?vue&type=script&lang=js"
import style0 from "./List-edit.vue?vue&type=style&index=0&id=6dd26eda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd26eda",
  null
  
)

export default component.exports